<template>
  <div class="img-carousel-box">
    <!-- ipad pc -->
    <v-row no-gutters class="d-none d-sm-flex" v-if="files.length">
      <div class="d-flex">
        <div class="thumb mr-5">
          <div :style="{ height: maxThumbHeight + 'px' }">
            <div
              class="thumb-box"
              :style="{
                transform: `translate3d(0px, ${arrowHeight + 'px'}, 0px)`
              }"
            >
              <ul>
                <li
                  v-for="(item, i) in files"
                  :key="i"
                  class="mb-4"
                  :class="{ active: currentIndex === i }"
                >
                  <div
                    v-if="item.type === 'image'"
                    class="img-wrap"
                    :style="{
                      width: thumbHeight + 'px',
                      height: thumbHeight + 'px'
                    }"
                  >
                    <!-- <shopmall-zoom-img :src="item.file"></shopmall-zoom-img> && youTubeId-->
                    <img
                      v-if="item.file"
                      style="margin: 0 auto"
                      @click="selectFile(i)"
                      :src="item.file + '?x-oss-process=image/resize,l_300'"
                    />
                    <span
                      @click="selectFile(i)"
                      class="video-icon left-video-icon"
                      v-show="i === 0 && youTubeId"
                    ></span>
                  </div>
                  <div v-else>
                    <!-- <video @click="selectFile(i)" autoplay="autoplay" :src="video01" controls="controls"></video> -->
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div
            class="arrow arrow-top"
            @click="prev"
            v-if="props.files.length > 5"
          >
            <v-icon icon="mdi-chevron-up" size="28"></v-icon>
          </div>
          <div
            class="arrow arrow-bot"
            @click="next"
            v-if="props.files.length > 5"
          >
            <v-icon icon="mdi-chevron-down" size="28"></v-icon>
          </div>
        </div>
        <div
          class="preview-area"
          :style="{ width: previewHeight + 'px', height: previewHeight + 'px' }"
        >
          <div
            class="enlarge-box d-none d-xs-none d-lg-block"
            ref="enlargeBoxRef"
          >
            <img
              :key="zoomImgWid"
              :src="files[currentIndex].file"
              class="zoom-img"
              :style="{
                width: zoomImgWid + 'px',
                marginTop: `-${position.y * cardinalityNum}px`,
                marginLeft: `-${position.x * cardinalityNum}px`
              }"
            />
          </div>
          <div
            class="img-wrap"
            ref="imgWrapRef"
            v-if="files[currentIndex].type === 'image'"
            @mouseout="handleMouseOut"
            @mousemove="handleMousemove"
          >
            <span
              class="video-icon"
              @click="videoPlayFn"
              v-show="currentIndex === 0 && youTubeId"
            ></span>
            <img
              :src="files[currentIndex].file"
              class="cont-img"
              ref="contImgRef"
            />
            <div
              class="zoom-btn d-none d-xs-none d-lg-block"
              ref="zoomBtnRef"
              :style="{ top: `${position.y}px`, left: `${position.x}px` }"
            ></div>
          </div>
          <div class="mdi left d-bloxk d-xs-none d-lg-none" @click="prev">
            <v-icon icon="mdi-chevron-left" size="50"></v-icon>
          </div>
          <div class="mdi right d-bloxk d-xs-none d-lg-none" @click="next">
            <v-icon icon="mdi-chevron-right" size="50"></v-icon>
          </div>
          <div class="van-icon-fullscreen"><v-icon @click="handlePreviewBigImage" icon="mdi-aspect-ratio" size="24" color="#fff"></v-icon></div>
        </div>
      </div>
    </v-row>
    <!-- phone -->
    <v-row no-gutters class="d-flex d-sm-none position-relative">
      <span
        class="video-icon"
        @click="videoPlayFn"
        v-show="phoneIndex === 0 && youTubeId"
      ></span>
      <swiper
        v-if="files.length"
        :key="swiperKey"
        ref="swiperRef"
        loop
        :modules="modules"
        :initialSlide="initialSlide"
        :spaceBetween="0"
        :slidesPerView="1"
        :slidesPerGroup="1"
        :centeredSlides="false"
        :resistance="true"
        :resistanceRatio="0.85"
        :pagination="{ clickable: true }"
        @swiper="onSwiper"
      >
        <swiper-slide
          v-for="(item, i) in files"
          :key="i"
        >
          <img :src="item.file + '?x-oss-process=image/resize,l_600'" class="w-100 h-100" />
        </swiper-slide>
      </swiper>
    </v-row>

    <!-- 视频播放 -->
    <product-youTube
      v-if="youTubeBol"
      :youTubeId="youTubeId"
      ref="youTubeRef"
      @closeFn="videoPauseFn"
      :width="youTubeWidth"
    ></product-youTube>
  </div>
</template>

<script setup>
import { Swiper, SwiperSlide } from "swiper/vue"
import { Pagination, A11y } from "swiper/modules"
const modules = [Pagination, A11y]
import "swiper/css"
import "swiper/css/pagination"
const { $multiPlatform  } = useNuxtApp();
const primaryColor = $multiPlatform.primaryColor;
const props = defineProps({
  files: {
    type: Object,
    default: () => {}
  },
  youTubeId: {
    type: String,
    required: true
  }
});
const {
  $BaseClickBurying,
  $MallPageName,
  $ClickSource,
  $Reporter
} = useNuxtApp();

// swiper 实例
const swiperRef = ref(null);
const initialSlide = ref(0);
const swiperKey = ref(0);
const onSwiper = (swiper) => {
  swiperRef.value = swiper
}

const imgWrapRef = ref(null);
const contImgRef = ref(null);
const enlargeBoxRef = ref(null);
const zoomBtnRef = ref(null);
const zoomImgWid = ref(0);
const position = ref({ x: 0, y: 0 });
const cardinalityNum = ref(0);
// 播放视频
const youTubeWidth = ref("100%");
const youTubeBol = ref(false);
const youTubeRef = ref("");
// 视频播放
const videoPlayFn = () => {
  handleMouseOut();
  youTubeBol.value = true;
  youTubeRef.value && youTubeRef.value.play();
};
// 视频隐藏和暂停
const videoPauseFn = () => {
  youTubeBol.value = false;
  youTubeRef.value && youTubeRef.value.stopVideo();
};
// 计算鼠标偏移量
const calculateMousePosition = (event, element) => {
  const rect = element.getBoundingClientRect();
  let clientX = event.clientX - rect.left - 100;
  let clientY = event.clientY - rect.top - 100;
  if (clientX < 0) {
    clientX = 0;
  } else if (clientX > contImgRef.value.width - 200) {
    clientX = contImgRef.value.width - 200;
  }
  if (clientY < 0) {
    clientY = 0;
  } else if (clientY > contImgRef.value.height - 200) {
    clientY = contImgRef.value.height - 200;
  }
  return { x: clientX, y: clientY };
};
// 鼠标移动
const handleMousemove = event => {
  if (enlargeBoxRef.value) enlargeBoxRef.value.style.visibility = "visible";
  position.value = calculateMousePosition(event, imgWrapRef.value);
  if (zoomBtnRef.value) zoomBtnRef.value.style.visibility = "visible";
};
// 鼠标移出
const handleMouseOut = () => {
  if (enlargeBoxRef.value) enlargeBoxRef.value.style.visibility = "hidden";
  if (zoomBtnRef.value) zoomBtnRef.value.style.visibility = "hidden";
};

const thumbHeight = ref(null);
const previewHeight = ref(null);
const maxThumbHeight = ref(null);
const currentIndex = ref(0);
const arrowHeight = ref(0);
const phoneIndex = ref(0);
const emit = defineEmits(["change-current-index","open-img-ppt"]);

watch(currentIndex, () => {
  emit("change-current-index", currentIndex.value);
})

/**
 * 计算缩略图高度
 */
const setCarousel = () => {
  const bodyWidth = window.innerWidth;
  let containerWidth = null;

  if (bodyWidth > 1600) {
    containerWidth = 1548 * 0.5 - 44;
  } else if (bodyWidth > 1279) {
    // 把1280改成1279解决1280的时候样式错乱
    containerWidth = 1152 * 0.5 - 44;
  } else if (bodyWidth > 1200) {
    containerWidth = 1152 - 40;
  } else if (bodyWidth > 992) {
    containerWidth = 960 - 40;
  } else if (bodyWidth > 768) {
    containerWidth = 744 - 40;
  } else {
    containerWidth = 528 - 40;
  }

  thumbHeight.value = parseInt(containerWidth * 0.15);
  previewHeight.value = parseInt(containerWidth * 0.85);
  maxThumbHeight.value = thumbHeight.value * 5;

  cardinalityNum.value = previewHeight.value / 200;
  zoomImgWid.value = previewHeight.value * cardinalityNum.value;

  // 获取视频所在盒子的宽高
  if (bodyWidth > 600) {
    youTubeWidth.value = previewHeight.value + 2 + "px";
  } else {
    youTubeWidth.value = "100%";
  }
};

/**
 * 切换图片
 * @param {i} 图片索引
 * @param {source} spec:代表点击规格颜色
 */
const selectFile = (i, source) => {
  currentIndex.value = i;
  phoneIndex.value = i;
  swiperKey.value += 1;
  initialSlide.value = i
  swiperRef.value.slideTo(i)

  videoPauseFn();
  if (source === "spec") {
    arrowHeight.value = 0;
    return false;
  }
};

const prev = () => {
  if (currentIndex.value === 0) {
    currentIndex.value = props.files.length - 1;
    if (props.files.length > 5) {
      arrowHeight.value =
        0 - (thumbHeight.value + 18) * (props.files.length - 5);
    }
  } else {
    if (
      Math.abs(arrowHeight.value) ==
      (thumbHeight.value + 18) * currentIndex.value
    ) {
      arrowHeight.value = arrowHeight.value + thumbHeight.value + 18;
    }
    currentIndex.value = currentIndex.value - 1;
  }
};

const next = () => {
  if (currentIndex.value + 1 >= props.files.length) {
    currentIndex.value = 0;
    if (props.files.length > 5) {
      arrowHeight.value = 0;
    }
  } else {
    if (
      Math.abs(arrowHeight.value) ==
      (thumbHeight.value + 18) * (currentIndex.value - 4)
    ) {
      arrowHeight.value = arrowHeight.value - thumbHeight.value - 18;
    }
    currentIndex.value = currentIndex.value + 1;
  }
};

// 手机端滑动图片
const updateCarousel = val => {
  phoneIndex.value = val;
};

/**
 * 显示规格图
 * @param {index} 规格图所在的索引
 */
const specImage = (index, source) => {
  selectFile(index, source);
};

// 自适应窗口大小
window.onresize = () => {
  setCarousel();
};

const handlePreviewBigImage = ()=>{
  emit('open-img-ppt')
  $BaseClickBurying(
    $MallPageName?.mallProductDetail,
    $ClickSource?.mallPreviewBigImage
  );
  $Reporter.click({event: 'e_preview_big_image'})
}

watch(
  props.files,
  () => {
    setCarousel();
  },
  { immediate: true }
);

defineExpose({
  specImage
});
</script>

<style scoped lang="scss">
.thumb {
  overflow: hidden;
  position: relative;
  .arrow {
    width: 100%;
    height: 30px;
    line-height: 30px;
    text-align: center;
    background: black;
    opacity: 0.3;
    cursor: pointer;
    color: #b1b1b1;
    z-index: 0;
    border-radius: 2px;
    position: absolute;
    .v-icon {
      vertical-align: center;
    }
  }
  .arrow-top {
    top: 0;
  }
  .arrow-bot {
    bottom: 0;
  }
  .arrow:hover {
    opacity: 0.15;
  }
  li {
    border: 1px solid #ededed;
    border-radius: 4px;
  }
  .active {
    border: 1px solid v-bind(primaryColor);
  }
  .thumb-box {
    transition: transform 300ms ease 0s;
    transition-duration: 0.3s;
  }
}
.img-wrap {
  width: 100%;
  height: 100%;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  border-radius: 4px;
  display: flex;
  position: relative;
  overflow: hidden;
  .cont-img {
    width: 100%;
    max-height: 100%;
    max-width: 100%;
    object-fit: contain;
    border-radius: 4px;
  }
  .zoom-btn {
    width: 200px;
    height: 200px;
    border: 1px solid #aaa;
    background: 50% top no-repeat #fede4f;
    opacity: 0.5;
    position: absolute;
    left: 0;
    top: 0;
    visibility: hidden;
    z-index: 1;
    cursor: move;
    transition: visibility 0.15s ease-in-out;
  }
}
.preview-area {
  position: relative;
  border: 1px solid #ededed;
  border-radius: 4px;
  position: relative;
  // overflow: hidden;
  .enlarge-box {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 100%;
    top: -1px;
    border: 1px solid #e4e4e4;
    text-align: center;
    overflow: hidden;
    border-radius: 4px;
    visibility: hidden;
    z-index: 99999;
    box-sizing: content-box;
    background-color: #ededed;
  }
  .mdi {
    position: absolute;
    width: 50px;
    height: 50px;
    background: white;
    opacity: 0.7;
    cursor: pointer;
    top: 50%;
    transform: translate(0, -50%);
  }
  .mdi:hover {
    opacity: 1;
  }
  .left {
    left: 0;
  }
  .right {
    right: 0;
  }
  .van-icon-fullscreen {
    position: absolute;
    z-index: 2;
    bottom: 10px;
    width: 28px;
    height: 24px;
    background-color: rgba(0, 0, 0, 0.2);
    right: 10px;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
    
    transition: all 0.3s ease;
    &:hover {
      background-color: rgba(0, 0, 0, 0.3);
    }
    i {
      background: none !important;
      color: #fff !important;
      opacity: 1 !important;
      margin-left: 1px;
    }
  }
}
:deep(.v-img__img--cover) {
  object-fit: contain;
}
:deep(.v-carousel__controls) {
  background: none;
  .v-btn {
    .v-btn__overlay {
      background: dodgerblue;
    }
    &.v-btn--active {
      .v-btn__content {
        .mdi-circle {
          color: v-bind(primaryColor);
        }
      }
    }
  }
}
.video-icon {
  cursor: pointer;
  display: inline-block;
  width: 60px;
  height: 60px;
  // background: url("@/assets/imgs/play.svg") 0 0 no-repeat;
  background-size: contain;
  position: absolute;
  left: 50%;
  top: 50%;
  margin: -30px 0 0 -30px;
  z-index: 2;
  background-image: url("@/assets/imgs/play.svg");
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 50%;
  &:hover {
    background-image: url("@/assets/imgs/play2.svg");
  }
  &.left-video-icon {
    width: 25px;
    height: 25px;
    background: url("@/assets/imgs/play.svg") 0 0 no-repeat;
    background-size: contain;
    position: absolute;
    left: 50%;
    top: 50%;
    margin: -12px 0 0 -12px;
    z-index: 2;
    // &:hover{
    //   background: url("@/assets/imgs/main-circles-small.png") -26px -25px no-repeat;
    // }
  }
}
.img-carousel-box {
  position: relative;
}

.swiper {
  width: 100%;
  height: 450px;
  img {
    object-fit: contain;
  }
}
</style>
